// Opt-in override so the devtools panel can be force-enabled outside local
// dev (e.g. production/staging) by setting this key in localStorage — useful
// for debugging analytics/flags/etc. on a deployed environment. Read once at
// module init (see `AppContents.tsx`), so setting it needs a reload to take
// effect.
const FORCE_ENABLE_STORAGE_KEY = 'evisort:devtools-enabled';

export function isDevToolsEnabled(): boolean {
  if (process.env.NODE_ENV !== 'production') return true;

  try {
    return localStorage.getItem(FORCE_ENABLE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}
